export const frontendURI = '/cat/country/';
export const backendURI = `/api${frontendURI}`;
